import {ReactElement,} from 'react';

import {Stack,} from '@mantine/core';

import {useApplicationAccounts} from '../hooks/useApplicationAccounts.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';


import {useApplicationAccountsSelection} from '../hooks/useApplicationAccountsSelection.ts';
import {
    ApplicationAccount,
    ApplicationAccountStatus,
} from '../types';
import {useParams} from "react-router-dom";
import {useApplicationAccountsPaging} from '../hooks/useApplicationAccountsPaging.ts';
import {useApplicationAccountsSearch} from '../hooks/useApplicationAccountsSearch.ts';
import {DataTableColumn} from 'mantine-datatable';
import {useApplicationAccountsTableColumns} from '../hooks/useApplicationAccountsTableColumns.tsx';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import classes from './RecordsTable.module.css';


export const RecordsTable = (
    {
        records,
        extraTools,
        settings,
    }: {
        records: ApplicationAccount[],
        extraTools?: ReactElement[],
        settings?: { label: string, onClick: () => void }[]
    }
) => {


    const {id: applicationId} = useParams()
    if (!applicationId) {
        throw new Error('applicationId is required parameter')
    }


    const {allowedActions} = useVerifiedPermissions()

    const {
        loading,
        visibleCount,
    } = useApplicationAccounts(applicationId);

    const {
        columns,
    } = useApplicationAccountsTableColumns(applicationId);

    const {
        page,
        limit,
        handleItemsPerPageChange,
        handlePageChange,
    } = useApplicationAccountsPaging(visibleCount);

    const {
        handleFilterByKeyword,
    } = useApplicationAccountsSearch();

    const {
        selection,
        handleClearSelection,
        handleRowSelection,
    } = useApplicationAccountsSelection();

    let selectedRecords = [] as ApplicationAccount[];
    if (allowedActions.includes(rbacActions.DeleteAccountApplication)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(key => records.find(r => r.id === key))
                                .filter(Boolean) as ApplicationAccount[];
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={visibleCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as unknown as ApplicationAccount).id, true)
                    })
                }}
                rowClassName={(record) => {
                    if (record.accountApplicationStatus === ApplicationAccountStatus.ACTIVE) {
                        return classes.active;
                    } else if (record.accountApplicationStatus === ApplicationAccountStatus.INACTIVE) {
                        return classes.inactive;
                    }
                }}
                fetching={loading}
            />


        </Stack>
    );
};
